import { db } from "configs";
import { AccessStatusEnum } from "requests";

export const getLogs = () => db.pinLogins.toArray();

export const addLog = (log: { status: AccessStatusEnum; time: string }) =>
  db.pinLogins.add(log);

export const removeLogs = () => db.pinLogins.clear();
